module.exports = __webpack_public_path__ + "front/img/u4.ed0472c7.jpg";